import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ApiGo from '../../../actions/ApiGo';
import comm_data from '../../../comm_data';
import { ADD_RESPONSE, ADD_RESPONSE_JSON } from '../../../stores/reducer_add';
import DropdownAdmin from './DropdownAdmin';
import { ADD_RESIDENTS_ARRAY } from '../../../stores/reducer_residentsArray';
import { ADD_USERS_ARRAY } from '../../../stores/reducer_usersArray';


const AddUsersADMIN = (props) => {
    const { t } = useTranslation()
    const store_institution = useSelector(state => state.store_beds.institutions)
    const institutions = { id: "", keys: store_institution }
    const [inputData, setInputData] = useState({});
    const [pwdInconsistent, setPwdInconsistent] = useState(false);
    const store_res_array = useSelector(state => state.store_residents.orign_residents_array)
    const [residentRow, setResidentRow] = useState(store_res_array);


    const dispatch = useDispatch();

    const [dropdown, setDropdown] = useState(false);
    function toggleDropdown() { setDropdown(!dropdown) }
    const roleSelections = ["superdoctor", "doctor", "admin"]
    const [returnRole, setReturnRole] = useState("superdoctor");
    const [returnInstitution, setReturnInstitution] = useState('');
    // useEffect(() => {
    //     if(store_res_array.length===0){
    //         ApiGo.getResidents()
    //         .then(res=>{
    //             setResidentRow(res)
    //             dispatch(ADD_RESIDENTS_ARRAY(res))
    //         })
    //         .catch(err=>{console.log(err);})
    //     }
    //     else{ setResidentRow(store_res_array) }
    // }, [store_res_array]);

    useEffect(() => {
        console.log("ININININ", store_institution)

    }, [store_institution])


    function handleInput(value, index) {
        let _addText = {}
        switch (index) {
            // case 0: _addText = {email:`${value}@${comm_data.INSTITUTION}.com`}; break;
            case 0: _addText = { email: `${value}` }; break;

            case 3: _addText = { last_name: value }; break;
            case 4: _addText = { first_name: value }; break;
            case 5:
                setPwdInconsistent(false)
                if (inputData.checkPwd !== undefined) {
                    let _index = value.length - 1
                    if (value[_index] !== inputData.checkPwd[_index]) { setPwdInconsistent(true) }
                }
                _addText = { encrypted_password: value }
                break;
            case 6:
                setPwdInconsistent(false)
                if (inputData.encrypted_password !== undefined) {
                    let _index = value.length - 1
                    if (value[_index] !== inputData.encrypted_password[_index]) { setPwdInconsistent(true) }
                }
                else { setPwdInconsistent(true) }
                _addText = { checkPwd: value }
                break;
            default:
                break;
        }
        setInputData({ ...inputData, ..._addText })
    }

    function handleSubmission() {
        let _add = {
            "role": returnRole,
            "resident_assign": resident_assign.join(","),
            "institution": returnInstitution,
            "unit_id": 1
        }
        let _data = { ...inputData, ..._add }
        if (_data.checkPwd !== _data.encrypted_password) { setPwdInconsistent(true) }
        else {
            ApiGo.postCreate_User(_data)
                .then((res) => {
                    dispatch(ADD_RESPONSE({ status: 200, statusText: "success", type: "create_user" }))
                    ApiGo.putCreate_Residents_Assign(_data)
                        .then(res => {
                            ApiGo.getUsers()
                                .then(res => {
                                    dispatch(ADD_USERS_ARRAY(res.users))
                                    props.hide()
                                })
                                .catch(() => { props.hide() })
                        })
                        .catch(err => { console.log(err); })
                })
                .catch(err => {
                    dispatch(ADD_RESPONSE({ status: err.status, statusText: err.statusText, type: "create_user" }))
                    return err.response
                })
                .then(res => { dispatch(ADD_RESPONSE_JSON(res)) })
        }
    }
    let _inputDiv = ["GLOBAL.ACCOUNT", "ADMIN.CONNECTION_HIS_PAGE.ROLE", "GLOBAL.INSTITUTION", "GLOBAL.LAST_NAME", "GLOBAL.FIRST_NAME", "GLOBAL.PASSWORD", "GLOBAL.COMFIRM_PASSWORD"].map((res, index) => <div key={index} className='fx-d-r w-100 h-10 fx-ccc'>
        <div className='w-25 btn_type _title fx-ccc '>{t(res)}</div>
        <div className="w-75">
            {/* {(index !== 1) ? <>
                <input className='w-100'
                    maxLength={(index === 5 || index === 6) ? "20" : (index === 0) ? "40" : "10"}
                    type={(index === 5 || index === 6) ? "password" : "text"}
                    onChange={e => { handleInput(e.target.value, index) }}
                    autoComplete='new-password' />
                <div className='h-0 w-100 _line'></div>
            </> :
                <div className='w-75'>
                    <DropdownAdmin
                        index={"0"}
                        data={{ id: returnRole, keys: roleSelections }}
                        toggleDropdown={toggleDropdown}
                        closeToggle={dropdown}
                        returnData={setReturnRole} />
                </div>
            } */}
            {index === 0 && <> <input className='w-100'
                maxLength={40}
                type={"text"}
                onChange={e => { handleInput(e.target.value, index) }}
                autoComplete='new-password' />
                <div className='h-0 w-100 _line'></div></>}

            {index === 1 && <div className='w-75'>
                <DropdownAdmin
                    index={"0"}
                    data={{ id: returnRole, keys: roleSelections }}
                    // toggleDropdown={toggleDropdown}
                    // closeToggle={dropdown}
                    returnData={setReturnRole} />
            </div>
            }
            {index === 2 && <div className='w-75'>
                <DropdownAdmin
                    index={"0"}
                    data={{ id: returnInstitution, keys: store_institution }}
                    // toggleDropdown={toggleDropdown}
                    // closeToggle={dropdown}
                    returnData={setReturnInstitution} />

                {/* <>{JSON.stringify(institutions, null, 2)}</> */}
            </div>}


            {index > 2 && <> <input className='w-100'
                maxLength={(index === 5 || index === 6) ? "20" : (index === 0) ? "40" : "10"}
                type={(index === 5 || index === 6) ? "password" : "text"}
                onChange={e => { handleInput(e.target.value, index) }}
                autoComplete='new-password' />
                <div className='h-0 w-100 _line'></div></>}

            {inputData.encrypted_password !== undefined ? index === 5 && pwdInconsistent ? <div className='pos-a'>密碼不一致</div> : null : null}
        </div>
    </div>)


    const [selectionEff, setSelectionEff] = useState(false);
    const [selected, setSelected] = useState([]);
    const [resident_assign, setResident_assign] = useState([]);
    useEffect(() => {
        let _arr = []
        residentRow.forEach(() => { _arr.push(false) });
        setSelected(_arr)
    }, [residentRow])

    function click_trans_color(_index, _id) {
        let _arr = selected
        let _res_ass_arr = resident_assign
        _arr[_index] = !_arr[_index]
        if (_arr[_index]) { _res_ass_arr.push(_id) }
        else {
            let _i = _res_ass_arr.indexOf(_id)
            if (_i > -1) { _res_ass_arr.splice(_i, 1) }
        }
        setResident_assign(_res_ass_arr)
        setSelected(_arr)
    }

    return (
        <>
            <div className='h-80 w-100 fx-d-r'>
                {/* <div className='w-30 fx-d-c h-100 font-l '>
                <div className='w-100 h-10 fx-ccc'>
                    <div className='w-100 btn_type _title fx-ccc'>{t("DASHBOARD.UNASSIGNED_RESIDENT")}</div></div>
                <div className='w-100 h-88 mac_input beige_border ovy-a'>{residentRow.map((res, index)=>
                    <div key={res.first_name+index} className={`font-ml res_layout ${(selected[index])? "add":"none"}`}
                        onMouseLeave={()=>{ setSelectionEff(true)}}
                        onMouseDown={()=>{ setSelectionEff(false)}}
                        onClick={()=>{click_trans_color(index, res.id)}}>
                        {selectionEff? <>
                            <div className='corner_frame _bl'></div>
                            <div className='corner_frame _br'></div>
                            <div className='corner_frame _tl'></div>
                            <div className='corner_frame _tr'></div>
                        </>:null}
                        {res.first_name}
                        {res.last_name}
                    </div>)}
                </div>
            </div> */}
                <div className='w-70 h-100 font-l fx-d-c fx-cspbt pad-15 l'>
                    {_inputDiv}
                </div>
            </div>
            <div className="wrap-personal-btn w-100 h-10 fx-fec" style={{ marginTop: '35px' }}>
                <div className="h-100 l-s-container fx-d-r">
                    <div className="fx-ccc w-50 btn_type" onClick={handleSubmission}>{t('GLOBAL.CONFIRM')}</div>
                    <div className="fx-ccc w-50 btn_type" onClick={props.hide}>{t('GLOBAL.CANCEL')}</div>
                </div>
            </div>
        </>
    );

}
export default AddUsersADMIN;